import * as React from "react"

const BlogAuthor = () => {

  return (
    <div className="p-6 border-[3px] border-black">
      <div className="md:flex">
        <img className="self-start rounded-full h-auto w-[120px] md:w-[140px]" src={'../../author-img.png'} alt="@takeshi_du"/>
        <div className="mt-4 md:mt-0 md:ml-6">
          <div className="flex items-center">
            <p className=" bg-black text-white py-1 px-2 text-xs font-bold rounded">この記事を書いた人</p>
            <p className="author_name ml-2 font-bold">Takeshi Sugimori</p>
          </div>
          <p className="mt-2">フリーランスでWebデザイン〜フロントエンドのコーディングまでを担当。EC-CUBE4向けプラグイン「UICube」開発。Designupではホームページ作成に関する記事を書いています。</p>
          <ul className="mt-3 flex">
            <li><a className="font-bold" href="https://twitter.com/takeshi_du">Twitter</a></li>
            <li className="ml-3"><a className="font-bold" href="https://www.facebook.com/profile.php?id=100070857406446">Facebook</a></li>
            <li className="ml-3"><a className="font-bold" href="https://qiita.com/takeshi_du">Qiita</a></li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default BlogAuthor